import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TurnAiIntoMeasurableBusinessOutcomes from "./sections/TurnAiIntoMeasurableBusinessOutcomes";
import OurCoreExpertise from "./sections/OurCoreExpertise";
import EvaluateYourAiReadiness from "./sections/EvaluateYourAiReadiness";
import TheRoiOfAiIntegration from "./sections/TheRoiOfAiIntegration";
import OurStrategicRoadmap from "./sections/OurStrategicRoadmap";
import ReadyToScale from "./sections/ReadyToScale";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TurnAiIntoMeasurableBusinessOutcomes />
      <OurCoreExpertise />
      <EvaluateYourAiReadiness />
      <TheRoiOfAiIntegration />
      <OurStrategicRoadmap />
      <ReadyToScale />
      <Footer />
    </div>;
}